import React from 'react';
import { motion } from 'framer-motion';
type SystemNodeProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  label: string;
  icon?: ReactNode;
  image?: string;
  color?: string;
  glowColor?: string;
  active?: boolean;
  delay?: number;
  children?: ReactNode;
};
export function SystemNode({
  x,
  y,
  width,
  height,
  label,
  icon,
  image,
  color = '#1e293b',
  glowColor = '#3b82f6',
  active = false,
  delay = 0,
  children
}: SystemNodeProps) {
  const nodeId = `node-${x}-${y}-${label.replace(/\s/g, '')}`;
  return <motion.g initial={{
    opacity: 0,
    scale: 0.8
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.6,
    delay,
    type: 'spring',
    stiffness: 100
  }} data-id="element-57">
      {/* Glow filter */}
      <defs data-id="element-58">
        <filter id={`glow-${nodeId}`} x="-50%" y="-50%" width="200%" height="200%" data-id="element-59">
          <feGaussianBlur stdDeviation="4" result="coloredBlur" data-id="element-60" />
          <feMerge data-id="element-61">
            <feMergeNode in="coloredBlur" data-id="element-62" />
            <feMergeNode in="SourceGraphic" data-id="element-63" />
          </feMerge>
        </filter>
        <linearGradient id={`bg-${nodeId}`} x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-64">
          <stop offset="0%" stopColor={color} stopOpacity="0.95" data-id="element-65" />
          <stop offset="100%" stopColor={color} stopOpacity="0.8" data-id="element-66" />
        </linearGradient>
      </defs>

      {/* Active glow ring */}
      {active && <motion.rect x={x - 4} y={y - 4} width={width + 8} height={height + 8} rx="12" fill="none" stroke={glowColor} strokeWidth="2" filter={`url(#glow-${nodeId})`} initial={{
      opacity: 0
    }} animate={{
      opacity: [0.3, 0.8, 0.3]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} data-id="element-67" />}

      {/* Main container */}
      <rect x={x} y={y} width={width} height={height} rx="8" fill={`url(#bg-${nodeId})`} stroke={active ? glowColor : '#334155'} strokeWidth={active ? 2 : 1} data-id="element-68" />

      {/* Image if provided */}
      {image && <image href={image} x={x + width / 2 - 30} y={y + 15} width="60" height="40" preserveAspectRatio="xMidYMid meet" data-id="element-69" />}

      {/* Icon placeholder area */}
      {icon && <foreignObject x={x + width / 2 - 16} y={y + 15} width="32" height="32" data-id="element-70">
          <div style={{
        color: glowColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }} data-id="element-71">
            {icon}
          </div>
        </foreignObject>}

      {/* Label - removed sublabel */}
      <text x={x + width / 2} y={image ? y + height - 15 : y + height / 2 + 5} fill="white" fontSize="13" fontWeight="600" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" data-id="element-72">
        {label}
      </text>

      {children}
    </motion.g>;
}